// extracted by mini-css-extract-plugin
export default {"pick-select-text":"picker_pick-select-text__YNGDc"};